/**
 * @file user.js
 * Exports constants pertaining to users.
 */

export const USER_LOG_IN = 'USER_LOG_IN';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const USER_REGISTER = 'USER_REGISTER';
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD';
export const USER_SET_ROLE = 'USER_SET_ROLE';
export const USER_ROLE_EDITOR = 'USER_ROLE_EDITOR';
export const USER_ROLE_ANONYMOUS = 'USER_ROLE_ANONYMOUS';



// WEBPACK FOOTER //
// ./src/constants/user.js